import { type } from "jquery";
import store from "../../store/index";
import axios from "axios";

export default {
  name: "ChangeactivityStatusPopup",
  props: {

    activityid: {
      type: String,
      default: "",
    },
    currentstatus: {
      type: String,
      default: "",
    },
    activitystatusreload:{
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      idToken: "",
      headerValues: "",
      baseapi: process.env.VUE_APP_Service_URL,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patientschedule/`,
      statusesList: [],
      loadingBlock: false,
      status:""
    };
  },
  async mounted() {
    this.status = this.currentstatus;
    this.idToken = store.getters.getIdToken;
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.listScheduleStatuses();
  },
  methods: {
    async closeChangeScheduleModal() {
      this.$emit("closeModal");
    },
    async listScheduleStatuses() {
      await axios
        .get(
          `${this.baseapi}/management/statusmaster/getall?StatusType=Activity`,
          this.headerValues
        )
        .then((res) => {
          this.statusesList = res.data;
        })
        .catch((err) => console.log("error getting schedule statuses"));
    },
   
    async changeScheduleStatus() {
      const idToken = store.getters.getIdToken;
      this.loadingBlock = true;
        try {
            await axios.put(
              `${this.baseapi}/management/patientschedule/updateactivitystatus?id=${this.activityid}&status=${this.status}`,null,
              {
        headers: {
          Authorization: "Bearer " + idToken,
          "Content-Type": "application/json",
        },
      }
            );
          this.loadingBlock = false;
          console.log("Updated status successfully");
          alert("Status updated successfully");
          this.$emit("changeStatus",this.activitystatusreload);
          this.$emit("closeModal");
        } catch (err) {
          console.log("error updating status", err);
          this.loadingBlock = false;
        }
    },

    closemodal() {
      this.$emit("closeModal");
    },
  },
};
